import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const PortraitPage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Portrait Page</p>
      </Container>
    </Layout>
  );
}

export default PortraitPage
